import React, {Component} from 'react';
import {Button, Form, FormControl, FormGroup, InputGroup} from 'react-bootstrap';
import {fetch_folders} from '../../views/Folders/actions';
import DesignResourcesPanel from '../../components/designResourcesPanel';
import CustomFolder from '../../components/customFolder';
import {withRouter} from 'react-router-dom'
import {connect} from 'react-redux';

class FolderPanel extends Component {

	constructor(props) {
		super(props);
		this.state = {
			selectedFolder : 'home',
			folders : [],
            data : [],
            searchActive: false,
            searchKeywords : '',
		}
	}

	componentDidMount() {
		if (this.props.user) {
			fetch_folders()
	        .then(data => data.json())
	        .then(data => {
	            data = data.data;
	            data = data.filter(x => (x.folder.type === 'photo'/* || x.folder.type == 'purchases'*/))
	            return data;
	        })
	        .then(data => {
	            this.setState({folders: data, data: data})
	        })
	        .catch((err) => {
	            console.log('Error fetching folders');
	        })
	    }
	}

    fetchSearchResults = () => {
        if (this.state.searchKeywords == '') {
            this.setState({
                searchActive : false,
                data : this.state.folders
            })
            return;
        }
        const searchResults = this.state.folders.filter(element => element.folder.name.toLowerCase().startsWith(this.state.searchKeywords.toLowerCase()));
        this.setState({
            data : searchResults
        })
    }

    searchFieldOnChange = (e) => {
        this.setState({
            searchActive : true,
            searchKeywords : e.target.value
        }, this.fetchSearchResults)
    }

    SearchBar = () => (
        <div className="nav_content_search_container" style={{padding: 12, paddingTop: 20}}>
            <Form onSubmit={this.fetchSearchResults}>
                <FormGroup>
                    <InputGroup style={{width: "100%"}}>
                        <FormControl
                            style={{fontSize: 14, fontFamily: 'Montserrat', height: 42, borderRadius: 4}}
                            placeholder= {'Search folders'}
                            value={this.state.searchKeywords}
                            type="text"
                            onChange={(e) => this.searchFieldOnChange(e)}/>
                        {this.state.searchActive ?
                            (<span onClick={() => this.setState({searchActive: false, searchKeywords: ''}, this.fetchSearchResults)} style={{cursor: 'pointer', position: 'absolute', right: 12, top: 9, fontSize: 22, zIndex: 100, color: '#C8CDD4'}} className="fas fa-times fa-2x fas-light" />)
                            : (<span onClick={this.fetchSearchResults} style={{position: 'absolute', cursor: 'pointer', right: 12, top: 9, fontSize: 22, zIndex: 100, color: '#C8CDD4'}} className="fas fa-search fa-2x fas-light" />)
                        }
                    </InputGroup>
                    <Button style={{'display': 'none'}} type='submit'/>
                </FormGroup>
            </Form>
        </div>)

    FoldersHomeView = () => (
        <div>
            {this.state.data
            .map((x,idx) => (
            <div key={idx} className="folder_icon" style={{'width': '100%', 'height': '72px', 'cursor': 'pointer', 'padding': '10px','textAlign':'left'}} onClick={() => this.setState({'selectedFolder': x.folder._id})}>
                <img style={{'paddingRight': '10px','height':'50px'}} src="https://img.icons8.com/cotton/64/000000/folder-invoices--v1.png"/><span style={{'fontSize': '1.5rem', 'fontWeight': '500'}}>{x.folder.name}</span>
            </div>
            ))
            }
        </div>)


	render() {
		if (this.state.selectedFolder === 'home') {
            return (
                <React.Fragment>
                    <this.SearchBar/>
                    <this.FoldersHomeView/>
                </React.Fragment>
            );
        }
        else {
            const folder = this.state.folders.filter(x => x.folder._id === this.state.selectedFolder)[0].folder;
            if (folder.type === 'photo') {
                folder.resources = folder.resources.map(x => {
                    x['src'] = global.config.server_path + x['path']; 
                    if (x['low_path']) {
                        x['low_src'] = global.config.server_path + x['low_path']; 
                    }
                    return x;
                })
                return (
                    <div style={{ height: 'calc(100vh - 198px)', overflowY: 'auto' }}>
                        <div 
                            onClick={() => this.setState({'selectedFolder' : 'home'})}
                        >
                            <span style={{marginLeft: 12, marginBottom: 4, 'fontSize': '1.2rem', 'fontWeight': '600', 'float': 'Left',cursor: "pointer"}} >Back</span>
                            <br />
                        </div>
                        <DesignResourcesPanel
                            on_drag_start={this.props.image_drag_start} 
                            on_drag={this.props.image_drag} 
                            on_drag_end={this.props.image_drag_end} 
                            on_click={this.props.add_image} 
                            image_height={'126px'} 
                            col_size={6} 
                            resources={folder.resources}   
                        />
                    </div>
                )
            }
            else {
                return (
                    <div>
                        <CustomFolder 
                            resources={folder.resources} 
                            view_type="panel_view" 
                            back_button_on_click={(() => this.setState({'selectedFolder' : 'home'}))}
                            on_click =  {this.props.purchases_on_click}
                        />
                    </div>
                )
            }
            
            
        }
	}

}

const mapStateToProps = function(state) {
    return {
        user: state.user
    }
}

const mapDispatchToProps = dispatch => {
    return {
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FolderPanel));